import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const GET_EXCEPTION_DICTIONARY_FOR_DELIVERY = gql`
    query ExceptionDictionaryQuery {
        getExceptionDictionaryForDelivery {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            actionDescription
            isUploadsImages
            showPodExample
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export interface ExceptionSubReasonType {
    code: string;
    textZh: string;
    textEn: string;
    textEs: string;
}

export interface ExceptionDictionaryType {
    exceptionReasonCode: string;
    primaryType: string;
    secondaryTypeZh: string;
    secondaryTypeEn: string;
    secondaryTypeEs?: string;
    actionDescription: string;
    isUploadsImages: boolean;
    showPodExample: boolean;
    exceptionSubReasons?: ExceptionSubReasonType[];  // 二级原因列表（包含国际化信息）
}

export interface ExceptionDictionaryResponse {
    getExceptionDictionaryForDelivery: ExceptionDictionaryType[];
}

export const getExceptionDictionaryForDelivery = async () => {
    const { data } = await client.query<ExceptionDictionaryResponse>({
        query: GET_EXCEPTION_DICTIONARY_FOR_DELIVERY,
        fetchPolicy: 'cache-first'
    });
    return data?.getExceptionDictionaryForDelivery || [];
};  
